import { Button, ButtonProps } from '@mui/material';

export default function FilledButton({ sx, ...props }: ButtonProps) {
  return <Button variant="contained" sx={{ fontSize: '16px', fontWeight: 700, ...sx }} {...props} />;
}
